export const UseCreateDineInReservation = async (dineInReservationObj: any) => {
	try {
		const response = await fetch(`${process.env.REACT_APP_API_URL ?? "http://3.9.77.124:3001"}/api/reservation/create_dine_in_reservation`, {
			method: 'POST',
			headers: {'Content-Type': 'application/json'},
			
			body: JSON.stringify({
				guestsNr: dineInReservationObj.guestsNr,
				reservationTime: dineInReservationObj.reservationTime,
				reservationName: dineInReservationObj.reservationName,
				dineInAdId: dineInReservationObj.dineInAdId,
				userId: dineInReservationObj.userId,
				cartId: dineInReservationObj.cartId
			}),
		});
		const data = await response.json();
		
		if (response && response.status === 201 && data) {
			console.log("UseCreateDineInReservation data: ", data);
			return data;
		} else {
			//data && data.message && toast.error(data.message);
			return null;
		}
	} catch (e) {
		console.log(e);
	}
}

/* export const UseCreateTakeOutReservation = async (takeOutReservationObj: any) => {
	try {
		const response = await fetch(`${process.env.REACT_APP_API_URL ?? "http://3.9.77.124:3001"}/api/reservation/create_take_out_reservation`, {
			method: 'POST',
			headers: {'Content-Type': 'application/json'},
			
			body: JSON.stringify({
				reservationTime: takeOutReservationObj.reservationTime,
				reservationName: takeOutReservationObj.reservationName,
				takeOutAdId: takeOutReservationObj.takeOutAdId,
				mealsNr: takeOutReservationObj.mealsNr,
				userId: takeOutReservationObj.userId,
			}),
		});
		let result = null;
		const status = response.status;
		if (status === 201) {
			result = await response.json();
		}
		return { result, status };
	} catch (e) {
		console.log(e);
	}
} */

export const UseCreateTakeOutReservation = async (takeOutReservationObj: any) => {
	try {
		const response = await fetch(`${process.env.REACT_APP_API_URL ?? "http://3.9.77.124:3001"}/api/reservation/create_take_out_reservation`, {
			method: 'POST',
			headers: {'Content-Type': 'application/json'},
			credentials: 'include',
			body: JSON.stringify({
				reservationTime: takeOutReservationObj.reservationTime,
				reservationName: takeOutReservationObj.reservationName,
				takeOutAdId: takeOutReservationObj.takeOutAdId,
				mealsNr: takeOutReservationObj.mealsNr,
				userId: takeOutReservationObj.userId,
				cartId: takeOutReservationObj.cartId
			}),
		});
		
		const data = await response.json();
		if (response && response.status === 201 && data) {
			console.log("UseCreateTakeOutReservation data: ", data);
			return data;
		} else {
			//data && data.message && toast.error(data.message);
			return null;
		}
	} catch (error) {
		console.error("UseCreateTakeOutReservation error: ", error);
	}
}

export const UseActivateDineInReservation = async (dineInReservationId: any) => {
	try {
		const response = await fetch(`${process.env.REACT_APP_API_URL ?? "http://3.9.77.124:3001"}/api/reservation/activate_dine_in_reservation/${dineInReservationId}`, {
			method: 'PUT',
			headers: {'Content-Type': 'application/json'},
			
		});
		let result = null;
		const status = response.status;
		if (status === 201) {
			result = await response.json();
		}
		return { result, status };
	} catch (e) {
		console.log(e);
	}
}

export const UseActivateTakeOutReservation = async (takeOutReservationId: any, mealsNr: number) => {
	try {
		const response = await fetch(`${process.env.REACT_APP_API_URL ?? "http://3.9.77.124:3001"}/api/reservation/activate_take_out_reservation/${takeOutReservationId}`, {
			method: 'PUT',
			headers: {'Content-Type': 'application/json'},
			credentials: 'include',
			body: JSON.stringify({
				mealsNr: mealsNr,
			})
		});
		let result = null;
		const status = response.status;
		if (status === 201) {
			result = await response.json();
		}
		return { result, status };
	} catch (e) {
		console.log(e);
	}
}

export const UseGetAllDineInReservationsByUserId = async (userId: string) => {
	try {
		const response = await fetch(`${process.env.REACT_APP_API_URL ?? "http://3.9.77.124:3001"}/api/reservation/get_all_dine_in_reservations_by_user_id/${userId}`, {
			method: 'GET',
			headers: {'Content-Type': 'application/json'},
			credentials: 'include',
		});
		let result = null;
		const status = response.status;
		if (status === 200) {
			result = await response.json();
		}
		return { result, status };
	} catch (e) {
		console.log(e);
	}
}

export const UseGetAllTakeOutReservationsByUserId = async (userId: string) => {
	try {
		const response = await fetch(`${process.env.REACT_APP_API_URL ?? "http://3.9.77.124:3001"}/api/reservation/get_all_take_out_reservations_by_user_id/${userId}`, {
			method: 'GET',
			headers: {'Content-Type': 'application/json'},
			credentials: 'include',
		});
		let result = null;
		const status = response.status;
		if (status === 200) {
			result = await response.json();
		}
		return { result, status };
	} catch (e) {
		console.log(e);
	}
}

export const UseGetReservationsById = async (reservationId: string) => {
	try {
		const response = await fetch(`${process.env.REACT_APP_API_URL}/api/reservation/get_reservation_by_id/${reservationId}`, {
			method: 'GET',
			headers: {'Content-Type': 'application/json'},
			credentials: 'include',
		});
		let result = null;
		const status = response.status;
		if (status === 200) {
			result = await response.json();
		}
		return { result, status };
	} catch (error) {
		console.log(`UseGetReservationsById - Error: ${error}`);
	}
}

export const UseGetReservationsByUserId = async (userId: string) => {
	try {
		const response = await fetch(`${process.env.REACT_APP_API_URL}/api/reservation/get_all_reservations_by_user_id/${userId}`, {
			method: 'GET',
			headers: {'Content-Type': 'application/json'},
			credentials: 'include',
		});
		let result = null;
		const status = response.status;
		if (status === 200) {
			result = await response.json();
		}
		return { result, status };
	} catch (error) {
		console.log(`UseGetReservationsById - Error: ${error}`);
	}
}